import { post, get } from '../request'
import { API_SUCCESS, API_FAILURE } from '~/helper/constant/api_status'
import ApiResponse from '~/model/response'

export const viewPackage = (token) => {
    return new Promise(function (resolve, reject) {
        try {
            get('package', token).then((response) => {
                resolve(response)
            })
        } catch ($e) {
            resolve(null)
        }
    })
}

export const activePackage = (token) => {
    return new Promise(function (resolve, reject) {
        try {
            get('package/active', token).then((response) => {
                resolve(response)
            })
        } catch ($e) {
            resolve(null)
        }
    })
}

export const addPackage = (data, token) => {
    return new Promise(function (resolve, reject) {
        try {
            post('package/add', token, data).then((response) => {
                resolve(response)
            })
        } catch ($e) {
            resolve(null)
        }
    })
}

export const getPackage = (id, token) => {
    return new Promise(function (resolve, reject) {
        try {
            get('package/edit/' + id, token).then((response) => {
                resolve(response)
            })
        } catch ($e) {
            resolve(null)
        }
    })
}

export const editPackage = (id, data, token) => {
    return new Promise(function (resolve, reject) {
        try {
            post('package/update/' + id, token, data).then((response) => {
                resolve(response)
            })
        } catch ($e) {
            resolve(null)
        }
    })
}

export const togglePackage = (id, token) => {
    return new Promise(function (resolve, reject) {
        try {
            get('package/status/' + id, token).then((response) => {
                resolve(response)
            })
        } catch ($e) {
            resolve(null)
        }
    })
}
